import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import AdminLogin from "../pages/admin/login/page";
import AdminLayout from "../pages/admin/components/AdminLayout";
import AdminOverview from "../pages/admin/overview/page";
import AdminClients from "../pages/admin/clients/page";
import AdminProgress from "../pages/admin/progress/page";
import AdminFinance from "../pages/admin/finance/page";
import AdminSystem from "../pages/admin/system/page";
import AdminChangePassword from "../pages/admin/change-password/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/change-password",
    element: <AdminChangePassword />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      {
        path: "overview",
        element: <AdminOverview />,
      },
      {
        path: "clients",
        element: <AdminClients />,
      },
      {
        path: "progress",
        element: <AdminProgress />,
      },
      {
        path: "finance",
        element: <AdminFinance />,
      },
      {
        path: "system",
        element: <AdminSystem />,
      },
      {
        path: "",
        element: <Navigate to="overview" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;